import "./floating-bubble.css";
import { FloatingBubble } from './floating-bubble';
export default FloatingBubble;